import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GetSetDataService} from '../../services/get-set-data.service';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-login-user',
  templateUrl: './login-user.component.html',
  imports: [
    NgIf
  ],
  styleUrls: ['./login-user.component.scss']
})
export class LoginUserComponent implements OnInit {

  @Input() loginURL = '#';
  @Input() smallView?: boolean;

  public userName?: string;

  constructor(private getSetData: GetSetDataService, private router: Router) {
  }

  ngOnInit() {
    this.getSetData.EmitterUserniceName.subscribe((username: string) => {
      this.userName = username;
    });
  }

  async logOutUser(event: any) {
    event.preventDefault();
    await this.getSetData.logoutUser();
  }
}
